<template>
  <div class="my">
    <div class="my_head">
      <div class="my_head_rgint">
        <img
          @click.stop="goMessage()"
          class="message"
          src="@/assets/mylogin/information.png"
          alt=""
        />
        <img
          @click.stop="goSetup()"
          class="setup"
          src="@/assets/mylogin/message.png"
          alt=""
        />
      </div>
      <div class="my_head_left">
        <img
          class="sculpture_img"
          v-lazy="
            timg
              ? `${$global.imgUrl}${timg}`
              : require('@/assets/mylogin/headimg.png')
          "
          alt=""
        />
        <div class="information" @click="goAuthentication">
          <div class="userName">
            {{ tokens ? userName : "请点击登录" }}
          </div>
          <div
            :class="[
              'authentications',
              tokens && information.user && information.user.customerType === 1
                ? 'bac'
                : '',
            ]"
            ref="banck"
          >
            <span class="not">
              {{ certified }}
            </span>
            <img
              v-show="
                tokens &&
                information.user &&
                information.user.customerType === 1
              "
              class="tu"
              ref="icon"
              src="@/assets/mylogin/arrow.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="us">
      <div class="user">
        <van-cell
          title-class="cell-title"
          value-class="cell-value"
          :border="false"
          is-link
        >
          <template #title>
            <span class="custom-title" style="font-weight: 500">我的订单</span>
          </template>
          <template #default>
            <span class="custom-title" @click="toOrder()">全部订单</span>
          </template>
        </van-cell>
        <div class="user-dist-icon">
          <van-grid :border="false" :column-num="4">
            <van-grid-item
              v-for="value in icon"
              :key="value.id"
              @click="toOrder(value.id)"
            >
              <van-badge
                v-show="value.counts !== 0"
                :content="value.counts"
                max="99"
              />
              <van-image
                class="van_img"
                :src="value.img"
                style="margin-bottom: 10px"
              />
              {{ value.text }}
            </van-grid-item>
          </van-grid>
        </div>
      </div>
    </div>
    <div class="bottom">
      <van-cell
        v-for="item in img"
        :key="item.id"
        is-link
        class="van_c"
        @click="handleClick(item.id)"
        :border="false"
      >
        <van-image class="van_image" :src="item.image" />
        {{ item.title }}
      </van-cell>
    </div>
  </div>
</template>

<script>
export default {
  name: "My",
  data() {
    return {
      icon: [
        {
          id: 1,
          img: require("@/assets/mylogin/daifukuan_icon.png"),
          text: "待付款",
          // 待付款计数
          counts: null,
        },
        {
          id: 3,
          img: require("@/assets/mylogin/gouwuche_icon.png"),
          text: "待发货",
          // 待收货计数
          counts: null,
        },
        {
          id: 4,
          img: require("@/assets/mylogin/daishouhuo_icon.png"),
          text: "待收货",
          // 待发货计数
          counts: null,
        },
        // {
        //   id: 4,
        //   img: require("@/assets/mylogin/daipingjia_icon.png"),
        //   text: "待评价",
        // },
        {
          id: 5,
          img: require("@/assets/mylogin/tuikuan_icon.png"),
          text: "退款/售后",
        },
      ],
      img: [
        {
          id: 1,
          title: "我的收藏",
          image: require("@/assets/mylogin/myFavorite.png"),
        },
        {
          id: 2,
          title: "我的书架",
          image: require("@/assets/mylogin/bookshelf.png"),
        },
        {
          id: 3,
          title: "我的课程",
          image: require("@/assets/mylogin/courseMy.png"),
        },
        {
          id: 4,
          title: "我的会议",
          image: require("@/assets/mylogin/meetingMy.png"),
        },
        {
          id: 5,
          title: "成为推广员",
          image: require("@/assets/mylogin/tuigung.png"),
        },
        {
          id: 6,
          title: "客服中心",
          image: require("@/assets/mylogin/customer-service.png"),
        },
      ],
      userName: "",
      tokens: "",
      // 登录后所有信息
      information: {},
      timg: "",
      certified: "",
      typeObj: {
        1: "期刊认证",
        2: "学者认证",
        4: "机构认证",
      },
    };
  },
  created() {
    this.tokens = sessionStorage.getItem("token");
    if (this.tokens) {
      this.getUserInfo();
      this.orderCount();
    }
  },
  methods: {
    getAuthentication() {
      switch (this.information.user.customerType) {
        case 1:
          this.certified = "未认证";
          break;
        case 2:
          this.certified = "已完成学者认证";
          break;
        case 4:
          this.certified = "已完成期刊认证";
          break;
        case 5:
          this.certified = "已完成机构认证";
          break;
      }
    },
    // 获取设置用户信息
    async getUserInfo() {
      let { content } = await this.$apis.loginServe.getUserInfo();
      sessionStorage.setItem("userInfo", JSON.stringify(content));
      this.information = content;
      this.timg = content ? content.headPhoto : "";
      // 判断用户名字隐藏
      if (content.user.customerType) {
        if (content.user.customerType !== 1) {
          content.user.customerType === 2
            ? (this.userName = content.name)
            : (this.userName = content.companyName);
        } else {
          this.userName = content.account.replace(
            /(\d{3})\d{6}(\d{2})/,
            "$1****$2"
          );
        }
      } else {
        this.userName =
          content.user.nickname ||
          content.account.replace(/(\d{3})\d{6}(\d{2})/, "$1****$2");
      }
      if (content.promoterId && content.promoterId !== "") {
        this.img[4].title = "推广商品";
      }
      this.getAuthentication();
    },
    // 跳转认证页
    async goAuthentication() {
      if (this.tokens) {
        if (this.information.user.customerType === 1) {
          const { data = { status: 999 } } =
            await this.$apis.userServe.authStatus(2);
          if (data.status === 0) {
            // 审核中
            this.$router.push({
              path: "scholarStatus",
              query: { title: this.typeObj[data.type] },
            });
          } else if (data.status === 1) {
            // 审核成功
            this.getUserInfo();
            this.orderCount();
          } else if (data.status === 2) {
            // 审核失败
            this.$router.push({
              name: "scholarFail",
              query: {
                cause: data.cause,
                title: this.typeObj[data.type],
              },
            });
          } else {
            this.$router.push("authentication");
          }
        } else if (this.information.user.customerType === 2) {
          this.$router.push("information");
        } else if (this.information.user.customerType === 4) {
          this.$router.push("/periodical-modification");
        } else if (this.information.user.customerType === 5) {
          this.$router.push("/institution-modification");
        }
      } else {
        this.$router.push("logins");
      }
    },
    to() {
      this.$router.push("logins");
    },
    // 跳转设置页
    goSetup() {
      if (this.tokens) {
        this.$router.push("setup");
      } else {
        this.$router.push("logins");
      }
    },
    goMessage() {
      if (this.tokens) {
        this.$router.push("message");
      } else {
        this.$router.push("logins");
      }
    },
    // 跳转订单列表页
    toOrder(type) {
      if (this.tokens) {
        switch (type) {
          case 5:
            this.$router.push({
              name: "aftermarket",
            });
            break;

          default:
            this.$router.push({
              name: "orders",
              query: {
                type,
              },
            });
        }
      } else {
        this.$router.push("logins");
      }
    },
    // 点击的是哪一项
    async handleClick(id) {
      if (id === 6) {
        this.$router.push("customer-service");
      } else if (this.tokens) {
        switch (id) {
          case 1:
            this.$router.push("collect");
            break;
          case 2:
            this.$router.push("bookshelf");
            break;
          case 3:
            this.$router.push("mycourse");
            break;
          case 4:
            this.$router.push("mymeeting");
            break;
          case 5:
            if (
              this.information.promoterId &&
              this.information.promoterId !== ""
            ) {
              let res = await this.$apis.extendServe.hasExtendLimits();
              if (res.resultCode === "200") {
                if (res.data.fgDis === 1) {
                  // 推广功能关闭
                  this.$router.push("/extend/close-extend");
                } else {
                  this.$router.push("/extend");
                }
              }
            } else {
              // 无推广权限
              this.$router.push("/extend/no-extend");
            }
            break;
        }
      } else {
        this.$router.push("logins");
      }
    },
    // 订单数量统计
    async orderCount() {
      const resp = await this.$apis.myServe.orderCount();
      this.icon[0].counts = resp.data.primaryOrder.waitPayCount;
      this.icon[1].counts = resp.data.waitSendCount;
      this.icon[2].counts = resp.data.waitReceiveCount;
    },
  },
};
</script>

<style lang="scss" scoped>
.my {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  box-sizing: border-box;

  .my_head {
    padding-top: calc(constant(safe-area-inset-top));
    padding-top: calc(env(safe-area-inset-top));
    width: 100%;
    height: 225px;
    background: #222b35;
    border-radius: 0px 0px 8px 8px;
    position: relative;
    overflow: hidden;

    .my_head_rgint {
      position: absolute;
      top: calc(56px + constant(safe-area-inset-top));
      top: calc(56px + env(safe-area-inset-top));
      right: 19px;

      .message {
        width: 20px;
        height: 20px;
      }

      .setup {
        width: 20px;
        height: 20px;
        margin-left: 19px;
      }
    }

    .my_head_left {
      // margin-top: 93px;
      margin-top: calc(93px - constant(safe-area-inset-top));
      margin-top: calc(93px - env(safe-area-inset-top));
      width: 100%;
      height: 60px;
      display: flex;

      .sculpture_img {
        margin-left: 21px;
        width: 52px;
        height: 52px;
        border-radius: 50%;
      }

      .information {
        margin-left: 14px;
        flex: 1;

        .userName {
          height: 21px;
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 21px;
        }

        .authentications {
          display: inline-block;
          align-items: center;
          margin-top: 12px;
          height: 20px;
          line-height: 19px;
          color: #fff;
          // background: #3c444d;
          border-radius: 10px;

          .not {
            font-size: 12px;
            font-weight: 400;
            color: #fff;
            opacity: 0.6;
          }

          .tu {
            margin-left: 7px;
            width: 5px;
            height: 9px;
          }
        }

        .bac {
          padding: 0 8px;
          background-color: rgba(255, 255, 255, 0.12);
        }
      }
    }
  }

  .us {
    width: 100%;
    position: relative;

    .user {
      margin: -52px auto 0;
      width: 94%;
      height: 119px;
      background: #ffffff;
      border-radius: 8px;
      overflow: hidden;

      .cell-title {
        font-size: 15px;
        font-weight: 500;
        color: #333333;
      }

      .cell-value {
        font-size: 13px;
        font-weight: 400;
        color: #999;
        font-family: PingFangSC-Regular, PingFang SC;
      }

      .user-dist-icon {
        width: 100%;
        background: #ffffff;
        border-radius: 8px;

        .van-grid {
          width: 100%;

          .van-grid-item {
            font-size: 12px;
            height: 67px;
            position: relative;

            .van_img {
              width: 22px;
              height: 22px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 17px;
            }

            .van-badge {
              position: absolute;
              top: 0px;
              right: 28px;
            }
          }
        }
      }

      .van-cell__right-icon {
        font-size: 10px;
      }
    }
  }

  .bottom {
    width: 94%;
    margin: 12px auto 0;
    border-radius: 8px;
    overflow: hidden;

    .van_c {
      .van_image {
        width: 20px;
        height: 20px;
        margin-bottom: -4px;
        margin-right: 6px;
      }
    }

    .van-icon-arrow {
      font-size: 10px;
    }
  }
}
</style>
